export enum WalletType {
    HOT = 0,
    COLD = 1,
}